import type { SearchDataModel } from "@/entities/data-model";

export const TYPE_TO_LETTER_MAPPING = {
    records: "r",
    stories: "s",
    trees: "t",
    photos: "p",
} as const;

export const LETTER_TO_TYPE_MAPPING: Record<string, keyof SearchDataModel["types"]> = {
    r: "records",
    s: "stories",
    t: "trees",
    p: "photos",
};

export const convertTypesToLetters = (types: SearchDataModel["types"]): string =>
    Object.entries(types)
        .filter(([, isSelected]) => isSelected)
        .map(([typeKey]) => TYPE_TO_LETTER_MAPPING[typeKey as keyof typeof TYPE_TO_LETTER_MAPPING])
        .join("");
